import {
    Component,
    inject,
    signal,
    ChangeDetectionStrategy,
} from '@angular/core'
import {
    FormControl,
    FormGroup,
    ReactiveFormsModule,
    Validators,
} from '@angular/forms'
import { Router } from '@angular/router'
import { NgIcon, provideIcons } from '@ng-icons/core'
import {
    lucideCalendarDays,
    lucideCar,
    lucideClipboardList,
    lucideEye,
    lucideEyeOff,
    lucideLock,
    lucideMail,
    lucideUsers,
} from '@ng-icons/lucide'
import { HlmButtonImports } from '@spartan-ng/helm/button'
import { AuthStateService } from '../../auth/auth-state.service'

@Component({
    selector: 'app-page-admin-login',
    imports: [ReactiveFormsModule, ...HlmButtonImports, NgIcon],
    providers: [
        provideIcons({
            lucideCalendarDays,
            lucideCar,
            lucideClipboardList,
            lucideEye,
            lucideEyeOff,
            lucideLock,
            lucideMail,
            lucideUsers,
        }),
    ],
    templateUrl: './page-admin-login.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './page-admin-login.component.css',
})
export class PageAdminLoginComponent {
    private router = inject(Router)
    private authStateService = inject(AuthStateService)

    loginForm = new FormGroup({
        email: new FormControl('', [Validators.required, Validators.email]),
        password: new FormControl('', [Validators.required]),
    })

    isLoading = false
    errorMessage = ''
    showPassword = signal(false)

    async onSubmit() {
        if (this.loginForm.invalid) {
            this.loginForm.markAllAsTouched()
            return
        }

        this.isLoading = true
        this.errorMessage = ''

        const { email, password } = this.loginForm.value

        // TODO: Implement actual login API call
        // For now, mock login
        setTimeout(() => {
            // this.authStateService.setUser({
            //     id: '1',
            //     email: email!,
            //     name: 'Admin',
            //     role: 'admin',
            // })
            this.router.navigate(['/dashboard'])
            this.isLoading = false
        }, 1000)
    }
}
